'use strict';

require('../../style/index.less');

require('./index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/affix/style/index.tsx
 ** module id = 546
 ** module chunks = 0
 **/